import { render } from "./GetInAppPurchasedAmountPropsCmp.vue?vue&type=template&id=7f4951ae"
import script from "./GetInAppPurchasedAmountPropsCmp.vue?vue&type=script&lang=js"
export * from "./GetInAppPurchasedAmountPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__